import { getContentList, getContentById, queryUser } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'auditRecords',
  state: {
    tabledData: [],
    pagination: initPagination,
    userLists: [],
  },
  effects: {
    *getContentList({ payload }, { call, put }) {
      const res = yield call(getContentList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveContentList',
          payload: res.data,
        });
      }
      return res;
    },
    *getContentById({ payload }, { call }) {
      return yield call(getContentById, payload);
    },
    *queryUser({ payload }, { call, put }) {
      const res = yield call(queryUser, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveUser',
          payload: res.data,
        });
      }
    },
  },
  reducers: {
    saveContentList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
    saveUser(state, { payload }) {
      return { ...state, userLists: payload };
    },
  },
};
export default Model;
